import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sv2-step"
}
const _hoisted_2 = { class: "sv2-success-icon" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { style: {"margin-top":"24px"} }, "Message on its way", -1)
const _hoisted_4 = { class: "sv2-step__subtitle" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { style: {"margin-top":"32px"} }
const _hoisted_7 = {
  key: 1,
  class: "sv2-step"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", null, "Tell your admin about Ditto", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-step__subtitle" }, " Send a quick intro to whoever runs IT. We'll include an overview, a deployment guide, and a free trial. ", -1)
const _hoisted_10 = { class: "sv2-fields" }
const _hoisted_11 = { class: "sv2-field-row" }
const _hoisted_12 = { class: "sv2-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode(" Your first name"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_14 = { class: "sv2-input-wrap" }
const _hoisted_15 = { class: "sv2-input-wrap__icon" }
const _hoisted_16 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_17 = { class: "sv2-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode(" Your last name"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_20 = { class: "sv2-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("Your email"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_22 = { class: "sv2-input-wrap" }
const _hoisted_23 = { class: "sv2-input-wrap__icon" }
const _hoisted_24 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_25 = { class: "sv2-field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode(" School or organization"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_27 = { class: "sv2-input-wrap" }
const _hoisted_28 = { class: "sv2-input-wrap__icon" }
const _hoisted_29 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_30 = { class: "sv2-field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode(" Admin or IT contact email"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_32 = { class: "sv2-input-wrap" }
const _hoisted_33 = { class: "sv2-input-wrap__icon" }
const _hoisted_34 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_35 = { class: "sv2-actions" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "sv2-spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ph_check = _resolveComponent("ph-check")!
  const _component_ph_arrow_left = _resolveComponent("ph-arrow-left")!
  const _component_ph_user = _resolveComponent("ph-user")!
  const _component_ph_envelope_simple = _resolveComponent("ph-envelope-simple")!
  const _component_ph_buildings = _resolveComponent("ph-buildings")!
  const _component_ph_paper_plane_tilt = _resolveComponent("ph-paper-plane-tilt")!

  return (_ctx.submitted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ph_check, {
            size: 28,
            weight: "bold"
          })
        ]),
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(" We'll loop in your admin and a member of our team within a couple of business days. In the meantime, you can still open "),
          _createElementVNode("a", {
            href: _ctx.externalConnectUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            style: {"color":"inherit","font-weight":"600"}
          }, "Ditto Connect", 8, _hoisted_5),
          _createTextVNode(" and try sharing. ")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "sv2-btn-back",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
          }, [
            _createVNode(_component_ph_arrow_left, {
              size: 14,
              weight: "bold"
            }),
            _createTextVNode(" Back ")
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createVNode(_component_ph_user, {
                    size: 16,
                    weight: "fill"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payload.firstName) = $event)),
                  class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': _ctx.showErrors && !_ctx.payload.firstName }]),
                  placeholder: "Jane"
                }, null, 2), [
                  [
                    _vModelText,
                    _ctx.payload.firstName,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              (_ctx.showErrors && !_ctx.payload.firstName)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, "This field is required."))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payload.lastName) = $event)),
                class: _normalizeClass(["sv2-input", { 'sv2-input--error': _ctx.showErrors && !_ctx.payload.lastName }]),
                placeholder: "Smith"
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.payload.lastName,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.showErrors && !_ctx.payload.lastName)
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, "This field is required."))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, [
                _createVNode(_component_ph_envelope_simple, {
                  size: 16,
                  weight: "fill"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payload.email) = $event)),
                type: "email",
                class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': _ctx.showErrors && !_ctx.payload.email }]),
                placeholder: "jane@school.edu"
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.payload.email,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            (_ctx.showErrors && !_ctx.payload.email)
              ? (_openBlock(), _createElementBlock("p", _hoisted_24, "This field is required."))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("span", _hoisted_28, [
                _createVNode(_component_ph_buildings, {
                  size: 16,
                  weight: "fill"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payload.orgName) = $event)),
                class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': _ctx.showErrors && !_ctx.payload.orgName }]),
                placeholder: "Acme University"
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.payload.orgName,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            (_ctx.showErrors && !_ctx.payload.orgName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, "This field is required."))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, [
                _createVNode(_component_ph_envelope_simple, {
                  size: 16,
                  weight: "fill"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payload.adminEmail) = $event)),
                type: "email",
                class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': _ctx.showErrors && !_ctx.payload.adminEmail }]),
                placeholder: "it@school.edu"
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.payload.adminEmail,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            (_ctx.showErrors && !_ctx.payload.adminEmail)
              ? (_openBlock(), _createElementBlock("p", _hoisted_34, "This field is required."))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("button", {
            class: "sv2-btn-back",
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('back')))
          }, [
            _createVNode(_component_ph_arrow_left, {
              size: 14,
              weight: "bold"
            }),
            _createTextVNode(" Back ")
          ]),
          _createElementVNode("button", {
            class: "sv2-btn-primary",
            type: "button",
            disabled: _ctx.submitting,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
          }, [
            (_ctx.submitting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_37))
              : _createCommentVNode("", true),
            _createTextVNode(" Send to admin "),
            (!_ctx.submitting)
              ? (_openBlock(), _createBlock(_component_ph_paper_plane_tilt, {
                  key: 1,
                  size: 16,
                  weight: "fill"
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_36)
        ])
      ]))
}